import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Account, TRUST_AUTH_EXCHANGE_PATH } from './components/Accounts';
import { theme } from './theme';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import Index from './components/index';
import SSOCallback from './components/SSOCallback';
import TrustAuthExchange from './components/TrustAuthExchange';
import { ReactComponent as SVGSprite } from './assets/icons/icons.svg';

// Restore styled-components v5 behaviour: don't forward unknown props (e.g. ui-lib `clickable`) to DOM elements
const shouldForwardProp = (propName: string, target: unknown) => (typeof target === 'string' ? isPropValid(propName) : true);

function App() {
  return (
    <Account>
      <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <ThemeProvider theme={theme}>
          <SVGSprite style={{ position: 'absolute', height: '0px', width: '0px' }} />
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              <Route path="/callback/:providerId" element={<SSOCallback />} />
              <Route path={TRUST_AUTH_EXCHANGE_PATH} element={<TrustAuthExchange />} />
              <Route path="/" element={<Index />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </StyleSheetManager>
    </Account>
  );
}

export default App;
